import { createApi } from '@reduxjs/toolkit/query/react';

import rtkFetchRequest from '../configs/rtkFetchRequest';

// Define a service using a base URL and expected endpoints
export const productsApi = createApi({
  reducerPath: 'products',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: (params = {}) => ({
        method: 'GET',
        endpoint: `/products`,
        body: params,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProductsQuery } = productsApi;
